import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"
import apiPath from "../../shared/apiPath";

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const role_fields = [{
  key: "id",
  label: "编号",
  thStyle: { width: "60px" }
  // isRowHeader:true,
},
{
  key: "code",
  label: "编码",
  sortable: true
},
{
  key: "name",
  label: "名称",
  sortable: true
},
{
  key: "description",
  label: "说明",
  sortable: true
},
{
  key: "is_valid",
  label: "状态",
  type: "boolean"
},
]
const privilege_fields = [{
  key: "id",
  label: "编号",
  // isRowHeader:true,
},
{
  key: "code",
  label: "编码",
  sortable: true
},
{
  key: "category",
  label: "类别",
  sortable: true
},
{
  key: "name",
  label: "名称",
  sortable: true
},
{
  key: "description",
  label: "说明",
  sortable: true
},
{
  key: "is_valid",
  label: "状态",
  type: "boolean"
},
]

const dataForm = {
  name: '',
  region: '',
  date1: '',
  date2: '',
  delivery: false,
  type: [],
  resource: '',
  desc: ''
}

///前端验证
const rules = {
  name: [{
    required: true,
    message: '请输入活动名称',
    trigger: 'blur'
  },
  {
    min: 3,
    max: 5,
    message: '长度在 3 到 5 个字符',
    trigger: 'blur'
  }
  ],
  region: [{
    required: true,
    message: '请选择活动区域',
    trigger: 'change'
  }],
  date1: [{
    type: 'date',
    required: true,
    message: '请选择日期',
    trigger: 'change'
  }],
  date2: [{
    type: 'date',
    required: true,
    message: '请选择时间',
    trigger: 'change'
  }],
  type: [{
    type: 'array',
    required: true,
    message: '请至少选择一个活动性质',
    trigger: 'change'
  }],
  resource: [{
    required: true,
    message: '请选择活动资源',
    trigger: 'change'
  }],
  desc: [{
    required: true,
    message: '请填写活动形式',
    trigger: 'blur'
  }]
}
const methods = {
  //获取角色
  async GetRoleList() {
    let data = await api.query_async({
      url: apiPath.admin.get_role_list,
      parameters: null,
      method: "get"
    });
    if (data) {
      return data[0].result.data.Result;
    }
    return null;
  },
  //新增角色子节点
  async AddOrDeletedRoleChildren(parentId, hasData, newData) {

    //如果hasData中不包含newData中的权限即为新增
    let _add = [],
      _del = [];
    for (var i in newData) {
      if (_.findIndex(hasData, {
        id: newData[i].id
      }) < 0) {
        _add.push({ id: newData[i].id });
      }
    }
    //如果newData中不包含hasData的权限即为删除
    for (var i in hasData) {
      if (_.findIndex(newData, {
        id: hasData[i].id
      }) < 0) {
        _del.push({ id: hasData[i].id });
      }
    }
    let query_settings = [];
    for (var i in _add) {
      let _p = new FormData();
      _p.append("roleId", _add[i].id);
      _p.append("parentId", parentId);
      query_settings.push({
        url: apiPath.admin.add_role_child,
        parameters: _p,
        method: "post"
      });
    }
    for (var i in _del) {
      let _p = new FormData();
      _p.append("roleId", _del[i].id);
      _p.append("parentId", parentId);
      query_settings.push({
        url: apiPath.admin.remove_role_child,
        parameters: _p,
        method: "post"
      });
    }

    let data = await api.query_all_async(query_settings);

    if (data) {
      return data[0].result.data.Success;
    } else {
      return false;
    }
  },
  //新增或删除角色权限
  async AddORDeleteRoleOwnPrivileges(roleId, hasData, newData) {
    //如果hasData中不包含newData中的权限即为新增
    let _add = [],
      _del = [];
    for (var i in newData) {
      if (_.findIndex(hasData, {
        id: newData[i].id
      }) < 0) {
        _add.push(newData[i]);
      }
    }
    //如果newData中不包含hasData的权限即为删除
    for (var i in hasData) {
      if (_.findIndex(newData, {
        id: hasData[i].id
      }) < 0) {
        _del.push(hasData[i]);
      }
    }

    let query_settings = [];
    for (var i in _add) {
      let _p = new FormData();
      _p.append("roleId", roleId);
      _p.append("privilegeId", _add[i].id);
      query_settings.push({
        url: apiPath.admin.add_role_own_privileges,
        parameters: _p,
        method: "post"
      });
    }
    for (var i in _del) {
      let _p = new FormData();
      _p.append("roleId", roleId);
      _p.append("privilegeId", _del[i].id);
      query_settings.push({
        url: apiPath.admin.remove_role_own_privileges,
        parameters: _p,
        method: "post"
      });
    }
    let data = await api.query_all_async(query_settings);
    if (data) {
      return data[0].result.data.Success;
    } else {
      return false;
    }
  },
  //获取根role
  async getRootRoleList() {
    let data = await api.query_async({
      url: apiPath.admin.get_role_root_list,
      parameters: null,
      method: "get"
    });
    if (data) {
      return _.filter(data[0].result.data.Result, { is_valid: true });
    }
    return null;
  },
  // 获取role的字节点
  async getRootRoleChildren(roleId) {
    let data = await api.query_async({
      url: apiPath.admin.get_role_children_list + roleId,
      parameters: null,
      method: "get"
    });
    if (data) {
      return data[0].result.data.Result;
    }
    return null;
  },
  async GetRoleOwnPrivilege(roleId) {
    let data = await api.query_async({
      url: apiPath.admin.get_role_own_privilege_list + roleId,
      parameters: null,
      method: "get"
    });
    if (data) {
      return data[0].result.data.Result;
    }
    return null;
  },
  async GetRoleAllPrivilege(roleId) {
    let data = await api.query_async({
      url: apiPath.admin.get_role_all_privilege_list + roleId,
      parameters: null,
      method: "get"
    });
    if (data) {
      return data[0].result.data.Result;
    }
    return null;
  },
  //导出所有用户权限列表
  async GetAllUserPrivileges(userIds) {
    //apiPath.admin.get_user_privilege_list
    let query_settings = [];
    for (var i in userIds) {
      query_settings.push({
        url: apiPath.admin.get_user_privilege_list + userIds[i],
        parameters: null,
        method: "get"
      });
    }
    let data = await api.query_all_async(query_settings);
    if (data) {
      return data
    } else {
      return null;
    }
  },
  async GetRoleAllPrivilegeList(roleIds) {
    let query_settings = [];
    for (var i in roleIds) {
      query_settings.push({
        url: apiPath.admin.get_role_all_privilege_list + roleIds[i],
        parameters: null,
        method: "get"
      });
    }
    let data = await api.query_all_async(query_settings);
    if (data) {
      return data
    } else {
      return null;
    }
  },
  //获取权限列表
  async GetPrivilege() {
    let data = await api.query_async({
      url: apiPath.admin.get_privilege_list,
      parameters: null,
      method: "get"
    });
    if (data) {
      return data[0].result.data.Result;
    }
    return null;
  },
}
const descriptor = {
  name: {
    type: 'string',
    required: true,
    validator: (rule, value) => value === 'muji',
  },
  age: {
    type: 'number',
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api.request({
          url: biz_data_helper.get_endpoint("test_fetch").url,
          parameters: {
            c: "a666"
          },
        }).then((res) => {


          if (value == res.data[0].echo) {
            resolve(res)
          } else {
            reject("测试没通过")
          }
        }).catch((err) => {
          reject(err)
        })
      });
    },
  },
};

const biz_data = new biz_data_helper.base_entity_helper(content_type, create, descriptor)
// export * from "../../shared/biz_data_helper"
export {
  role_fields,
  privilege_fields,
  dataForm,
  rules,
  biz_data,
  methods
}
